import React from 'react';
import { I18n } from 'aws-amplify';
import { AmplifyAuthenticator, AmplifySignIn, AmplifyForgotPassword } from '@aws-amplify/ui-react';
import { Translations } from '@aws-amplify/ui-components';
import * as AppConst from '../../components/AppConst';

/** ================================
*  サインイン画面
*  ================================*/
const Login = () => {
  // 日本語化
  const dict = {
    ja: {
      // 画面部品
      [Translations.FORGOT_PASSWORD_TEXT]: 'パスワードをお忘れですか？',
      [Translations.RESET_PASSWORD_TEXT]: 'パスワードをリセット',
      [Translations.BACK_TO_SIGN_IN]: 'サインインに戻る',
      [Translations.CODE_LABEL]: '検証コード *',
      [Translations.CODE_PLACEHOLDER]: '検証コードを入力',
      [Translations.NEW_PASSWORD_LABEL]: '新しいパスワード *',
      [Translations.NEW_PASSWORD_PLACEHOLDER]: '新しいパスワードを入力',
      // エラーメッセージ
      'User does not exist.': 'ユーザー名またはパスワードが違います',
      'Incorrect username or password.': 'ユーザー名またはパスワードが違います',
      'Username/client id combination not found.': 'ユーザーが存在しません',
      'Attempt limit exceeded, please try after some time.': '試行制限を超過しました。しばらくしてからもう一度お試しください',
      'Invalid verification code provided, please try again.': '指定された確認コードが無効です。もう一度お試しください',
      'Password does not conform to policy: Password not long enough': 'パスワードは8文字以上を入力してください',
      'Invalid password format': 'パスワードのフォーマットが不正です',
      'Password does not conform to policy: Password must have uppercase characters': 'パスワードには大文字を含めてください',
      'Password does not conform to policy: Password must have lowercase characters': 'パスワードには小文字を含めてください',
      'Password does not conform to policy: Password must have numeric characters': 'パスワードには数字を含めてください',
    },
  };
  I18n.putVocabularies(dict);
  I18n.setLanguage('ja');

  return (
    <AmplifyAuthenticator
      // @ts-ignore
      style={{ marginTop: 50, '--amplify-primary-color': AppConst.defaultColor, '--amplify-primary-tint': AppConst.defaultColor, '--amplify-primary-shade': AppConst.defaultColor, '--container-height': '100%' }}>
      <AmplifySignIn
        slot='sign-in'
        headerText='アカウントにサインイン'
        submitButtonText='サインイン'
        formFields={[
          {
            type: 'username',
            label: 'ユーザー名 *',
            placeholder: 'ユーザー名を入力',
            required: true,
          },
          {
            type: 'password',
            label: 'パスワード *',
            placeholder: 'パスワードを入力',
            required: true,
          },
        ]}
        hideSignUp={true}

      />
      <AmplifyForgotPassword
        slot='forgot-password'
        headerText='パスワードリセット'
        formFields={[
          {
            type: 'username',
            label: 'ユーザー名 *',
            placeholder: 'ユーザー名を入力',
            required: true,
          },
        ]}
        sendButtonText='送信'
        submitButtonText='送信'
      />
    </AmplifyAuthenticator>
  );
}

export default Login;
